<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Select Your Employer</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<form #f="ngForm" (ngSubmit)="onClose()">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 py-4">

    <p>
      Please take a moment to select your employer. It is important that we keep information as accurate as possible for reporting. <br>
      Press the save button when done.
    </p>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
      <mat-label>Company Name</mat-label>
      <input matInput placeholder="Company Name" [value]="defaultAccount.name" type="text" readonly (click)="onSelectAccount()" />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="defaultAccount.address">
      <mat-label>Address</mat-label>
      <input matInput placeholder="Address" [value]="defaultAccount.address" type="text" readonly />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="defaultAccount.city">
      <mat-label>City</mat-label>
      <input matInput placeholder="City" [value]="defaultAccount.city" type="text" readonly />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="defaultAccount.country">
      <mat-label>Country</mat-label>
      <input matInput placeholder="Country" [value]="defaultAccount.country" type="text" readonly />
    </mat-form-field>

    <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic" *ngIf="defaultAccount.industry">
      <mat-label>Industry</mat-label>
      <input matInput placeholder="Industry" [value]="defaultAccount.industry" type="text" readonly />
    </mat-form-field>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="px-3 py-2">

    <button
      type="submit"
      mat-raised-button
      [disabled]="!app.user.account_id || inProgress"
      color="primary"
      class="my-2 ml-1 mr-2"
      id="save">
      {{ alreadyUpdated ? 'Close' : 'Save' }}
    </button>

    <button
      mat-raised-button
      type="button"
      color="secondary"
      class="my-2 ml-1 mr-2"
      (click)="onSelectAccount()"
      matTooltip="Select your Employer">
      <mat-icon>business</mat-icon>
      Change Employer
    </button>

  </mat-dialog-actions>

</form>
